import {
  FormHelperText,
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from "@mui/material";
import XCircle from "../../assets/x-circle.svg";
import styles from "./styles";

import { useState } from "react";
import EyeOff from "../../assets/eye-off.svg";

const InputField = ({
  id,
  name,
  value,
  label,
  type,
  placeholder,
  showCross,
  errorMessage,
  handleCrossClick,
  InputProps,
  showPasswordToggle,
  ...props
}: TextFieldProps & { showCross?: boolean } & { errorMessage?: string } & {
  handleCrossClick?: () => void;
  showPasswordToggle?: boolean;
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPasswordType = type === "password";

  const getEndAdornment = () => {
    if (showPasswordToggle && isPasswordType) {
      return (
        <InputAdornment position="end">
          <IconButton
            onClick={() => setShowPassword((prev) => !prev)}
            sx={styles.inputPropsIcon}
            tabIndex={-1}
          >
            <img
              alt={showPassword ? "hide password" : "show password"}
              src={showPassword ? EyeOff : EyeOff}
              style={styles.inputPropsIcon}
            />
          </IconButton>
        </InputAdornment>
      );
    }
    if (showCross) {
      return (
        <InputAdornment position="end">
          <IconButton onClick={handleCrossClick} sx={styles.inputPropsIcon}>
            <img alt="x-circle" src={XCircle} style={styles.inputPropsIcon} />
          </IconButton>
        </InputAdornment>
      );
    }
    return undefined;
  };

  return (
    <>
      <TextField
        {...props}
        id={id}
        name={name}
        value={value}
        label={label}
        type={
          showPasswordToggle && isPasswordType && showPassword ? "text" : type
        }
        placeholder={placeholder}
        InputProps={
          InputProps ? InputProps : { endAdornment: getEndAdornment() }
        }
      />
      <FormHelperText sx={styles.errorMessage}>{errorMessage}</FormHelperText>
    </>
  );
};

export default InputField;
